import React from "react";
import { I18n } from "@lingui/react";
import styled from "styled-components";
import { t } from "@lingui/macro";
import {
  Button,
  ControlGroup,
  Thirds,
  Left,
  Center,
  Right,
} from "@conserveit/blocks";
import {
  GroupFooterProps as Props,
  getGroupedInsightsExportData,
} from "../../utils";
import { Exporter } from "../../../../components/Exporter";

const StyledThird = styled(Thirds)`
  width: 100%;
`;
const GroupFooter: React.FunctionComponent<Props> = ({
  moreCount,
  currentCount,
  totalCount,
  onLoadMore,
  onLoadAll,
  exportData,
  viewMode,
}) => {
  return (
    <I18n>
      {({ i18n }) => (
        <StyledThird>
          <Left>
            <span>
              {i18n._(
                t(
                  "show_more_grouped_rows.showing_count"
                )`Showing ${currentCount} of ${totalCount}`
              )}
            </span>
          </Left>
          <Center>
            <ControlGroup tight>
              {currentCount < totalCount && (
                <Button appearance="outline" primary thin onClick={onLoadMore}>
                  {i18n._(t("show_more_grouped_rows.show_more")`Show More`)} (+
                  {moreCount})
                </Button>
              )}
              {currentCount < totalCount && (
                <Button appearance="plain" primary thin onClick={onLoadAll}>
                  {i18n._(t("show_more_grouped_rows.show_all")`Show All`)} (
                  {totalCount})
                </Button>
              )}
            </ControlGroup>
          </Center>
          <Right>
            {viewMode === "insights" && exportData && (
              <Exporter
                data-cy="export-insight-list"
                appearance="outline"
                rawData={exportData}
                fileName="Grouped-Insights.csv"
                dataFormatter={getGroupedInsightsExportData}
              >
                Export List
              </Exporter>
            )}
          </Right>
        </StyledThird>
      )}
    </I18n>
  );
};

export default GroupFooter;
